import {
  Box,
  TextField
} from "@mui/material";
import { useEffect, useState } from "react";

const ConfirmPassword = ({
  onChange
}: {
  onChange: (_: string) => void
}) => {
  const [password, setPassword] = useState<string>('')
  const [confirmd, setConfirmd] = useState<string>('')
  const [match, setMatch] = useState<boolean>(false)

  const helperText = password.length < 7
    ? 'must be at least 7 characters'
    : password === password.toUpperCase()
      ? 'must contain a lowercase letter'
      : password === password.toLowerCase()
        ? 'must contain an uppercase letter'
        : !containsSpecialChars(password)
          ? 'must contain a special character'
          : !containsNumbers(password)
            ? 'must contain a number'
            : '';
  const error = !!helperText;

  useEffect(() => {
    if (match) {
      onChange(password)
    }
    else onChange('')
  }, [match, onChange, password])

  useEffect(() => {
    setMatch(!error && confirmd === password)
  }, [confirmd, error, onChange, password, setMatch])

  return (
    <Box>
      <TextField
        color={error ? 'error' : 'success'}
        error={error}
        helperText={helperText}
        label="Password"
        fullWidth
        type="password"
        onChange={e => setPassword(e.target.value)}
        required
        value={password}
      />
      <TextField
        color={match ? 'success' : 'error'}
        label="Confirm Password"
        fullWidth
        type="password"
        onChange={e => setConfirmd(e.target.value)}
        required
        value={confirmd}
      />
    </Box>
  );
}

export default ConfirmPassword;

function containsNumbers(str: string) {
  const numbers = /[\d]/;
  return numbers.test(str);
}
function containsSpecialChars(str: string) {
  const specialChars = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
  return specialChars.test(str);
}